const partners = [
  {
    id: 1,
    name: "Global Academics Research Academy",
    logo: "/assets/img/gara_logo.jpg",
    website: "#",
    description: "Collaborating on scholarship programs and research initiatives."
  },
  {
    id: 2,
    name: "Redeemer's College of Technology and Management",
    logo: "/assets/img/reclogo.png",
    website: "https://rectem.edu.ng/",
    description: "Supporting curriculum development and student internships."
  },
  {
    id: 3,
    name: "Chartered Institute of Risk & Security Management",
    logo: "/assets/img/CIRSM.jpg",
    website: "https://www.mycirsm.org/",
    description: "Partnering on public health research projects."
  },
  {
    id: 4,
    name: "Empirical Multidisciplinary Institute",
    logo: "/assets/img/empirical-logo.png",
    website: "https://empiricalmi.co.za/",
    description: "Partnering on public health research projects."
  }
];

export default partners;
